
<a-select
  v-model="localValue"
  :options="vSelectOptions"
  bind-by-object
  :id="id"
  :disabled="disabled"
  :placeholder="placeholder"
  :autocomplete="autocomplete"
  ref="select"
></a-select>
